import React from "react";

import { t } from "../../i18n";

export const HelpSettings: React.FC = () => {
  return (
    <div className="HelpSettings">
      <h3>{t("settings.help")}</h3>
      <div className="HelpSettings__section">
        <h4>{t("settings.shortcuts")}</h4>
        <p>{t("settings.shortcutsDescription")}</p>
        <button
          className="HelpSettings__button"
          onClick={() => {
            // This would trigger the keyboard shortcuts dialog
            // You can integrate with existing shortcuts action if available
            alert(t("settings.shortcutsPlaceholder"));
          }}
        >
          {t("settings.viewShortcuts")}
        </button>
      </div>
      <div className="HelpSettings__section">
        <h4>{t("settings.documentation")}</h4>
        <p>{t("settings.documentationDescription")}</p>
        <a
          className="HelpSettings__link"
          href="https://docs.excalidraw.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("settings.openDocumentation")}
        </a>
      </div>
      <div className="HelpSettings__section">
        <h4>{t("settings.about")}</h4>
        <p>{t("settings.aboutDescription")}</p>
      </div>
    </div>
  );
};
